export default "__VITE_ASSET__1PEM9ATC__"